import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

const strict = process.env.NODE_ENV !== 'production';

let currentAmountKey = `currentAmount.${Config.shop_id}.${Config.game_id}.${Config.currency.code}`;
let skipIntroKey = `skipIntro.${Config.shop_id}.${Config.game_id}`;
let volumeKey = `volume.${Config.shop_id}.${Config.game_id}`;

let volume = 0.25;

try {
    let localStorageAmount = localStorage.getItem(currentAmountKey);
    if(localStorageAmount) {
        localStorageAmount = JSON.parse(localStorageAmount);
        
        if(Config.amounts.some(e => e.id === localStorageAmount.id && e.amount === localStorageAmount.amount)) {
            Config.current_amount = localStorageAmount;
        }
    }

    let localStorageVolume = localStorage.getItem(volumeKey);
    if (localStorageVolume) {
        volume = parseFloat(localStorageVolume);
    }
} catch(e) {}

const state = {
    canvasReady: false,
    relayMethods: undefined,
    currentAmount: Config.current_amount,
    ticketsQuantity: 1,
    amounts: Config.amounts,
    amountWon: false,
    balance: Config.balance,
    message: '',
    currencySign: Config.currency.symbol,
    mute: volume == 0,
    volume: volume,
    device: undefined,
    isLogged: Config.is_logged,
    mode: Config.mode,
    ticketInProgress: false,
    explanationVisible: false,
    explanationCallback: false,
    pendingMessages: [],
    showOpenAllButton: false,
    openAllButtonDisabled: false,
    showCustomPlayButton: false,
    customPlayButtonDisabled: false,
    customPlayButtonText: false,
    popGracefulPause: false,
    hidePlayButton: false,
    lifetimeAmount: Config.lifetime_amount,
    integrationGateway: undefined,
    ticketBarcode: undefined,
};

const mutations = {
    setRelayMethods(state, relayMethods) {
        state.relayMethods = relayMethods;
    },
    updateCurrentAmount(state, amount) {
        Config.current_amount = amount;
        try{
            localStorage.setItem(currentAmountKey, JSON.stringify(Config.current_amount));
        } catch(e) {

        }
        state.currentAmount = Config.current_amount;
    },
    setAmountWon(state, amountWon) {
        state.amountWon = amountWon;
    },
    setBalance(state, balance) {
        state.balance = balance;
    }, 
    setMessage(state, payLoad) {
        if(Object.keys(payLoad).length && Object.keys(state.message).length) {
            state.pendingMessages.push(payLoad);
            return;
        }

        state.message = payLoad;
    },
    deletePendingMessage(state, index) {
        state.pendingMessages.splice(index, 1);
    },
    canvasReady(state) {
        state.canvasReady = true;
    },
    toggleMute(state) {
        state.relayMethods.clickEvent('toggleMute');
        state.mute = !state.mute;
        state.relayMethods.toggleMute(state.mute);
    },
    muteOn(state) {
        state.relayMethods.clickEvent('toggleMute');
        state.mute = true;
        state.relayMethods.toggleMute(state.mute);
    },
    muteOff(state) {
        state.relayMethods.clickEvent('toggleMute');
        state.mute = false;
        state.relayMethods.toggleMute(state.mute);
    },
    setVolume(state, volume) {
        state.relayMethods.setVolume(volume);
        state.volume = volume;

        try {
            localStorage.setItem(volumeKey, volume);
        } catch {

        }
    },
    setDevice(state, device) {
        state.device = device;
    },
    logout(state) {
        state.isLogged = false;
    },
    setConnectionStatus(state, status) {
        state.connectionStatus = status;
    },
    setTicketInProgress(state, status) {
        state.ticketInProgress = status;
    },
    setPopGracefulPause(state, status) {
        state.popGracefulPause = status;
        Config.popGracefulPause = status;
    },
    toggleExplanation(state, payload) {
        try {
            if(!Config.explanation_template || (!state.explanationVisible && localStorage.getItem(skipIntroKey))) {
                if(payload.callback) {
                    payload.callback();
                }
                return;
            }
        } catch(e) {
            console.log(e)
        }

        state.explanationVisible = !state.explanationVisible;

        if(!state.explanationVisible) {
            state.relayMethods.clickEvent('toggleExplanation');
        }

        state.explanationCallback = payload.callback;
        state.relayMethods.setExplanationStatus(state.explanationVisible);

        if(payload.dontShowIntro) {
            try {
                if(localStorage.setItem(skipIntroKey, 1)) {
                    return;
                }
            } catch(e) {
                console.log(e)
            }
        }
    },
    changeToReal(state) {
        state.mode = 'real';
        if (Config.balance_real !== undefined) {
            state.balance = Config.balance_real;
        }
    },
    showOpenAllButton(state) {
        state.showOpenAllButton = true;
        state.openAllButtonDisabled = false;
    },
    hideOpenAllButton(state) {
        state.showOpenAllButton = false;
    },
    disableOpenAllButton(state) {
        state.openAllButtonDisabled = true;
    },
    showCustomPlayButton(state, icon) {
        state.showCustomPlayButton = icon;
        state.customPlayButtonDisabled = false;
    },
    setCustomPlayButtonText(state, text) {
      state.customPlayButtonText = text;
    },
    hideCustomPlayButton(state) {
        state.showCustomPlayButton = false;
        state.customPlayButtonText = false;
    },
    disableCustomPlayButton(state) {
        state.customPlayButtonDisabled = true;
    },
    updateLifetimeAmount(state, amount) {
        state.lifetimeAmount = amount;
    },
    hidePlayButton(state) {
        state.hidePlayButton = true;
    },
    showPlayButton(state) {
        state.hidePlayButton = false;
    },
    setIntegrationGateway(state, gateway) {
        state.integrationGateway = gateway;
    },
    setTicketBarcode(state, barcode) {
        state.ticketBarcode = barcode;
    },
};

const getters = {
    winUp(state) { 
        return state.currentAmount.amount * state.ticketsQuantity * Config.max_quote;
    },
    currentAmount(state) { 
        return state.currentAmount.amount;
    }
};

const actions = {};

export default new Vuex.Store({ strict, state, mutations, getters, actions });
